import React from 'react';

const ProgrammeInfo = ({children}) => {
    return (
        <div>
            <h5 className="section-title d-block d-md-none">INNOVATION</h5>
            {children}
        </div>
    );
};

export default ProgrammeInfo;